<script setup lang="ts">
import PlaceHolder from '@/components/PlaceHolder/PlaceHolder.vue';
</script>

<template>
  <div :class="$style.placeHolderWrapper" data-test="agent-card-placeholder">
    <div :class="$style.avatar">
      <PlaceHolder />
    </div>
    <div :class="$style.basicInfo">
      <div :class="$style.profile">
        <div v-for="n in [1, 2, 3, 4]" :key="`basicInfo-${n}`" :class="$style.basicInfoItem">
          <PlaceHolder />
        </div>
      </div>
      <div :class="$style.chipsRow">
        <div v-for="n in [1, 2, 3]" :key="`chip-${n}`" :class="$style.chip">
          <PlaceHolder />
        </div>
      </div>
    </div>
    <div :class="$style.meta">
      <div :class="$style.badge">
        <PlaceHolder />
      </div>
      <div :class="$style.logo">
        <PlaceHolder />
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
@use '@/assets/variables' as *;

.placeHolderWrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: $border-radius-l;
  box-shadow: $elevation-minimal;

  @media (min-width: $viewport-sm-min) {
    display: grid;
    grid-template-columns: calc($space-1000 + $space-600) 1fr auto;
  }
}

.avatar {
  width: 100%;
  height: $space-1000 + $space-200;

  > div {
    height: 100%;
    border-radius: 0;
  }

  @media (min-width: $viewport-sm-min) {
    width: calc($space-1000 + $space-600);
    height: calc($space-1000 + $space-600);

    > div {
      border-radius: 0;
    }
  }
}

.basicInfo {
  display: flex;
  flex-direction: column;
  gap: $space-150; // 24px per Figma Agent Card v2
  padding: $space-100;

  @media (min-width: $viewport-sm-min) {
    justify-content: space-between;
    padding: $space-100 $space-200;
  }
}

.profile {
  display: flex;
  flex-direction: column;
  gap: $space-50;

  .basicInfoItem {
    width: 60%;
    height: $space-200;

    &:first-child {
      width: 40%;
    }
  }
}

.chipsRow {
  display: flex;
  flex-wrap: wrap;
  gap: $space-50;

  .chip {
    width: $space-800;
    height: $space-200;

    > div {
      border-radius: $space-25;
    }
  }
}

.meta {
  display: flex;
  gap: $space-50;
  align-items: center;
  justify-content: space-between;
  padding: $space-100;
  border-top: 1px solid $color-grey-60;

  @media (min-width: $viewport-sm-min) {
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    padding: $space-100 $space-100 $space-100 0;
    border-top: 0;
  }

  .badge {
    width: $space-400;
    height: $space-400;

    @media (min-width: $viewport-sm-min) {
      width: $space-500;
      height: $space-500;
    }

    > div {
      border-radius: 100%;
    }
  }

  .logo {
    width: $space-600;
    height: $space-400;

    @media (min-width: $viewport-sm-min) {
      width: $space-700;
      height: $space-500;
    }

    > div {
      border-radius: $space-25;
    }
  }
}
</style>
